<template>
    <div class="gwb-sign-up-city-field">
        <gwb-float-field
            :id="id"
            :name="name"
            :label="label"
            :error="error"
            :value="inputValue"
            autocomplete="off"
            @input="(event) => {
                $emit('input', event);
            }"
            @change="$emit('change', $event)"
            @blur="($event) => {
                  placePredictions = []
                  $emit('blur', $event);
            }"
        />
        <div v-if="placePredictions.length > 0" class="gwb-sign-up-city-field__dropdown">
            <ul class="gwb-sign-up-city-field__list">
                <li
                    v-for="(countryName, countryId) in window.gwbServer.availableCountries"
                    :key="countryId"
                    class="gwb-sign-up-city-field__item"
                >
                    <strong v-text="countryName"></strong>
                </li>
                <li class="gwb-sign-up-city-field__copyright">Powered by Google</li>
            </ul>
        </div>
    </div>
</template>

<script>
import GwbFloatField from './gwb-float-field.vue';

export default {

    name: 'GwbSignUpCountryField',

    components: {
        GwbFloatField,
    },

    props: {
        value: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            default: '',
        },

        name: {
            type: String,
            default: '',
        },

        label: {
            type: String,
            default: '',
        },

        error: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            inputValue: '',
            placePredictions: [],
        };
    },

    computed: {},

    watch: {
        value: {
            handler(val) {
                this.inputValue = val;
            },
            immediate: true,
        },
    },

    beforeCreate() {

    },

    methods: {},

};
</script>

<style lang="scss">
.gwb-sign-up-city-field {
    &__dropdown {
        position: relative;
        top: -0.8rem;
    }

    &__list {
        position: absolute;
        // Above form fields (z 10), below the DS overlay layer (popover 10110). This block
        // is duplicated verbatim in gwb-sign-up-city-field.vue as a global selector — keep
        // the z-index identical there or bundle load-order can override that one. (GWB-673)
        z-index: 100;
        width: 100%;
        margin: 0;
        padding: 0;
        list-style: none;
        background-color: #fefefe;
        border: 1px solid #cacaca;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    }

    &__item {
        border-bottom: 1px solid #cacaca;
        padding: 0.25rem 0.5rem;
        cursor: pointer;

        &:hover {
            background-color: #e6e6e6;
        }
    }

    &__copyright {
        padding: 0.25rem 0.5rem;
        text-align: right;
        font-size: 0.5em;
    }
}
</style>
